/* ==========================================================================
   CV 收藏（wishlist）—— 纯前端 localStorage，不依赖任何 app
   - 站点范围内生效：商品卡、集合页、搜索结果、相关商品
   - 用事件委托，所以 Dawn 的分面筛选 / 编辑器重渲染后无需重新绑定
   - 存储键：cv-wishlist-v1（JSON 数组，存 product id）
   ========================================================================== */
(function () {
  var KEY = 'cv-wishlist-v1';

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var arr = raw ? JSON.parse(raw) : [];
      return Object.prototype.toString.call(arr) === '[object Array]' ? arr : [];
    } catch (e) {
      return [];
    }
  }

  function save(ids) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(ids));
    } catch (e) {
      /* 隐私模式 / 存储被禁用：静默降级，不报错 */
    }
  }

  function sync() {
    var ids = read();
    var nodes = document.querySelectorAll('[data-cv-wish]');
    for (var i = 0; i < nodes.length; i++) {
      var btn = nodes[i];
      var on = ids.indexOf(btn.getAttribute('data-cv-wish')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var counters = document.querySelectorAll('[data-cv-wish-count]');
    for (var j = 0; j < counters.length; j++) {
      counters[j].textContent = String(ids.length);
      if (ids.length === 0) {
        counters[j].setAttribute('hidden', '');
      } else {
        counters[j].removeAttribute('hidden');
      }
    }
  }

  document.addEventListener('click', function (ev) {
    var target = ev.target;
    if (!target || !target.closest) return;
    var btn = target.closest('[data-cv-wish]');
    if (!btn) return;
    ev.preventDefault();

    var id = btn.getAttribute('data-cv-wish');
    var ids = read();
    var at = ids.indexOf(id);
    if (at === -1) {
      ids.push(id);
    } else {
      ids.splice(at, 1);
    }
    save(ids);
    btn.setAttribute('aria-pressed', at === -1 ? 'true' : 'false');
    sync();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }

  /* Shopify 主题编辑器里改动分区后重新同步 */
  document.addEventListener('shopify:section:load', sync);
})();
